// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box product-operation">
  <sub-header header="'Transfer funds to product'"></sub-header>

    <!-- Operation form -->

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">

        <tbody>
        <tr>
          <div class="alert alert--danger" ng-show="\$ctrl.cause">
            <span>Product number invalid {{\$ctrl.cause}}</span>
          </div>
          <td>1.</td>
          <td>Target product number</td>
          <td>
            <input
              required
              type="text"
              ng-model="\$ctrl.productNumber"
              ng-change="\$ctrl.readProductId()"
              ng-model-options="{updateOn: 'blur'}"
              maxlength="64"/>

          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Amount</td>
          <td><cash ng-model="\$ctrl.input.amount"
                  min="0.01"
                  ng-required="true"></cash></td>
        </tr>
        <tr>
          <td>3.</td>
          <td>Remarks</td>
          <td>
            <input
              type="text"
              ng-model="\$ctrl.input.remarks"
              ng-required="false">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="summary-actions">
        <signature-card
          file-id="\$ctrl.product.signatureCardFileId"
          product-group="\$ctrl.productGroup"
          product-status="\$ctrl.product.status"></signature-card>
        <button class="btn btn-warning" type="button"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-success" type="button"
                ng-click="\$ctrl.execute()"
                ng-disabled="\$ctrl.transactionForm.\$invalid || !\$ctrl.input.productId">
          Transfer
        </button>
      </div>
    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/transfer-to-product/transfer-to-product.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;